import {PrizeSlot} from "./prize-slot";

export class HubModule {
    id: number;
    enabled: boolean;
    type: string;
    sortOrder: number;
    machineId: string;
    slots = [];

    fromJson(dict: any): HubModule {
        this.id = dict.id;
        this.enabled = dict.enabled;
        this.type = dict.type;
        this.sortOrder = dict.sortOrder;
        this.machineId = dict.machineId;

        if (dict.slots && dict.slots.length) {
            for (let slotDict of dict.slots ) {
                let prizeSlot = new PrizeSlot().fromJson(slotDict);
                this.slots.push(prizeSlot);
            }
        }

        return this;
    }

    fromJsonArray(array: any[]): HubModule[] {
        let ret: HubModule[] = [];
        array.forEach((dict) => {
            ret.push(new HubModule().fromJson(dict));
        });
        return ret;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/hub-module.ts